import ToastContext, { ToastProvider } from './ToastContext';
import withToast from './WithToast.component';
import WrappedToast from './WrappedToast.component';

export default { ToastProvider, withToast, WrappedToast, ToastContext };
